<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2024-02-29 17:16:04
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-10 14:57:55
 * @FilePath: \jsczt_vue20240117\src\views\moblie\list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div >
      <div class="head">
        <div class="head_logo">
            <img src="../../assets/jscztmb_logo.png" alt="" />
        </div>
        <div class="head_name">
            江苏省预决算公开统一平台
        </div>
        <div class="head_nav">
          <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="activeTab === tab.id? 'nav_btn actives':'nav_btn'"
            
            @click="changeTab(tab.id)">
          {{ tab.name }}
          </div>
        </div>
      </div>
      <div class="content">
        <moblieTab v-if="activeTab" :num="activeTab"></moblieTab>
      </div>
      <div class="footers">
        主办：江苏省财政厅 备案序号：苏ICP备15009401号 公安备案号：32010602010331
        网站标识码：3200000098 江苏省财政厅版权所有
      </div>
    </div>
  </template>

<script>
import moblieTab from '../../components/moblieTab'
export default {
  name: 'list',
  components: {
    moblieTab
  },
  data () {
    return {
      activeTab: '5',
      tabs: [
        { name: '预决算公开管理文件', id: '5' },
        { name: '政府预决算公开', id: '8' },
        { name: '部门预决算公开', id: '25' }
      ]
    }
  },

  watch: {

  },
  async created () {
  },
  mounted () {
    this.update()
    
  },
  methods: {
    update(){
      this.activeTab=this.$store.state.sjParentid?this.$store.state.sjParentid:5
    },
    changeTab (id) {
      this.activeTab = id
      this.$store.commit('setSjParentid',id)
      this.$router.push({name:'list'})
    },
  }
}
</script>
  <style scoped>
  @import url("../../assets/list.css");
  #app{
    height:100%
  }
  </style>



// WEBPACK FOOTER //
// src/views/moblie/list.vue